<template>
  <div>
    <img
      :src="imgLetterJacketPlaceholder"
      class="responsive-img"
      alt="Letter Jacket Placeholder Image"
    >
  </div>
</template>

<script>
import imgLetterJacketPlaceholder from '../assets/letter-jacket-placeholder-image.jpg'
export default {
  name: 'LetterJacketPlaceholderImage',
  data () {
    return {
      imgLetterJacketPlaceholder
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/LetterJacketPlaceholderImage.vue